
export const recaptcha_site_key_v3 = '6LdEzMYqAAAAAIY0Gp21wwGLWyOZUrIA6sWgYVwD';
export const recaptcha_secret_key_v3 = '6LdEzMYqAAAAAPEZnWpmYZa0MWBjCel7UOhRfKXW';

export const recaptcha_site_key = '6LdCzcYqAAAAAPJqZoNJWzMSBrzlKwlbs9B61aZ6';
export const recaptcha_secret_key = '6LdCzcYqAAAAAKHpOo2ytI7bZFrqV1d3KreNCGMk';

export const ALL_COLORS = ["#AF3E45","#FCB94D","#00843F","#00A695","#5DA4BA","#006E9E","#003362", "#939393"];
export const ALL_CULTURES = ['Napraforgó', 'Kukorica', 'Repce', 'Szója'];
export const ALL_CULTURES2 = ['Paprika', 'Paradicsom', 'Uborka', 'Káposzta', 'Szőlő'];
export const ALL_CULTURES3 = ['Repce', 'Kalászos'];

export const MAX_FILE_SIZE = 10000000;

export const version = "3.0.3";

const dev = {
     API_URL: 'http://keichiro.net/kwizda3teszt/server/api',
     BASE_PATH : '/'
};
const test = {
     API_URL: '/kwizda3teszt/server/api',     //http://keichiro.net/kwizdateszt/server/api
     BASE_PATH : '/kwizda3teszt'
};
const prod = {
     API_URL: '/server/api',  //https://www.teszteljeingyen.hu/server/api
     //API_URL: 'https://www.teszteljeingyen.hu/server/api',
     //API_URL: 'http://knives.keichiro.net/server/api',
     BASE_PATH : ''
};

export const config = process.env.NODE_ENV === 'development' ? 
                         dev : process.env.NODE_ENV === 'test'? prod : prod;